// extracted by mini-css-extract-plugin
module.exports = {"container":"_1eis7fMb-43RXuKstTx8Q2","categoriesList":"_3iu-qgsCz_qvlmLRjJeqTi","item":"O3_rDTihxyfzUqJISSCPH","dot":"_34LP9KgwiOibCl902O37sE"};